/*
 * Bisou Rivage — retouches d'interface (version ALT, 14/10/2026 · 15/10 : t-shirt épuisé, menu ;
 *   15/10 après-midi : « Carte » libellée dans Vue, « Composer un diptyque » sur les collections, haut de la wishlist ;
 *   15/10 soir : « Nos collections » se déplie dans le menu ; fond opaque des visuels effacé sur les murs ;
 *   /pages/wishlist conduit à la liste ; le fond opaque a sa propre case, et s'efface aussi dans le zoom
 *   de la fiche et les cartes du Journal)
 * Va avec bisou-alt.css. Chaque partie ne tourne que si sa case est cochée (classe bvf-a-… sur <html>)
 * et s'efface en « Avant » (classe bvf-off) : rien n'est retiré du thème, on ajoute ou on masque.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  function has(c) { return root.classList.contains(c); }
  function isOff() { return has('bvf-off'); }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[bvf-alt]', e); } }
  /* 25/10 (site anglais) : hors français, les libellés écrits ici (menu du téléphone, « Découvrir » de l'accueil)
     passent par cette table. Un texte absent de la table reste tel quel. À passer en clés de langue quand
     locales/*.json seront libres (deux fiches les tenaient le 25/10).
     26/10 (langues) : l'espagnol et le japonais ont leur table, TR_LANGUE ; un texte qui n'y est pas prend
     l'anglais de TR, puis reste tel quel. Espagnol : « tú » partout, comme le reste du site (27/10). */
  var LANGUE = (root.getAttribute('lang') || 'fr').slice(0, 2).toLowerCase();
  var EN = !/^fr/i.test(root.getAttribute('lang') || 'fr');
  function selon(fr, en, es, ja) { return !EN ? fr : LANGUE === 'es' ? es : LANGUE === 'ja' ? ja : en; }
  var TR = {
    'Nos tirages': 'Our prints', 'Tous nos tirages': 'All prints', 'Voir': 'See', 'T': 'A', 't': 'a', 'ous nos tirages': 'll prints',
    'Sélections': 'Selections', 'Nouvelle sélection': 'New selection', 'Tirages limités': 'Limited editions',
    'Horizontales': 'Horizontal', 'Verticales': 'Vertical', 'Nos collections': 'Our collections',
    'Les plus votés': 'Most voted', '0 °C · Neige et sommets': '0 °C · Snow and summits', 'Au fil de l’eau': 'By the water', 'En ville': 'In the city',
    'Participer': 'Take part', 'Le vote': 'The vote', 'Choisissez la prochaine sélection.': 'Choose the next selection.',
    'Sur candidature': 'By application', 'Devenir artiste de la galerie': 'Become a gallery artist',
    'Vendez vos photos en tirages d’art, imprimés avec soin.': 'Sell your photographs as fine art prints, printed with care.',
    'Découvrir': 'Discover', 'Découvrir, offrir et accrocher': 'Discover, give and hang', 'Nos artistes': 'Our artists',
    'Le journal': 'The Journal', 'Atlas des photos': 'The Atlas', 'Notre histoire': 'Our story',
    'Offrir et accrocher': 'Give and hang', 'Offrir un tirage': 'Give a print', 'Tester des images côte à côte': 'Try prints side by side',
    'Créer un compte': 'Create account', 'Mes coups de cœur': 'My wishlist', 'Découvrir la suite de la page': 'See the rest of the page',
    'Un diptyque, ou plus': 'A diptych, or more', 'Essayez-les sur votre mur.': 'Try them on your wall.', 'Côte à côte': 'Side by side',
    'Posez 2 à 5 tirages côte à côte, à l’échelle, et voyez-les sur votre mur.': 'Place 2 to 5 prints side by side, to scale, and see them on your wall.',
    'L’Atlas des photos : où les tirages ont été pris': 'The Atlas: where the photos were taken', 'L’Atlas des photos →': 'The Atlas →',
    'Essayez-les ensemble, sur votre mur.': 'Try them together, on your wall.', 'Un tirage gardé. Trouvez-lui un compagnon.': 'One print saved. Find it a companion.',
    'Posez-les côte à côte, à l’échelle. Changez un cadre ou un format, puis ajoutez le tout au panier.': 'Place them side by side, to scale. Change a frame or a size, then add everything to your cart.',
    'On vous propose un deuxième tirage du même sens : essayez le diptyque sur votre mur.': 'We suggest a second print in the same orientation: try the diptych on your wall.',
    'Les 5 derniers, côte à côte': 'The last 5, side by side', 'Voir la liste': 'See the list', 'Voir le tirage': 'See the print',
    'Sommaire': 'Contents', 'Aucun tirage de cette collection avec ces filtres.': 'No prints in this collection match these filters.',
    'Tous nos autres tirages': 'All our other prints'
  };
  var TR_LANGUE = {
    es: {
      'Nos tirages': 'Nuestras láminas', 'Tous nos tirages': 'Todas las láminas', 'Voir': 'Ver', 'T': 'T', 't': 't', 'ous nos tirages': 'odas las láminas',
      'Sélections': 'Selecciones', 'Nouvelle sélection': 'Nueva selección', 'Tirages limités': 'Ediciones limitadas',
      'Horizontales': 'Horizontales', 'Verticales': 'Verticales', 'Nos collections': 'Nuestras colecciones',
      'Les plus votés': 'Las más votadas', '0 °C · Neige et sommets': '0 °C · Nieve y cumbres', 'Au fil de l’eau': 'A orillas del agua', 'En ville': 'En la ciudad',
      'Participer': 'Participar', 'Le vote': 'La votación', 'Choisissez la prochaine sélection.': 'Elige la próxima selección.',
      'Sur candidature': 'Por candidatura', 'Devenir artiste de la galerie': 'Hazte artista de la galería',
      'Vendez vos photos en tirages d’art, imprimés avec soin.': 'Vende tus fotos como láminas de arte, impresas con cuidado.',
      'Découvrir': 'Descubrir', 'Découvrir, offrir et accrocher': 'Descubrir, regalar y colgar', 'Nos artistes': 'Nuestros artistas',
      'Le journal': 'El Diario', 'Atlas des photos': 'El Atlas', 'Notre histoire': 'Nuestra historia',
      'Offrir et accrocher': 'Regalar y colgar', 'Offrir un tirage': 'Regalar una lámina', 'Tester des images côte à côte': 'Probar láminas lado a lado',
      'Créer un compte': 'Crear cuenta', 'Mes coups de cœur': 'Mi lista de deseos', 'Découvrir la suite de la page': 'Ver el resto de la página',
      'Un diptyque, ou plus': 'Un díptico, o más', 'Essayez-les sur votre mur.': 'Pruébalas en tu pared.', 'Côte à côte': 'Lado a lado',
      'Posez 2 à 5 tirages côte à côte, à l’échelle, et voyez-les sur votre mur.': 'Coloca de 2 a 5 láminas lado a lado, a escala, y míralas en tu pared.',
      'L’Atlas des photos : où les tirages ont été pris': 'El Atlas: dónde se tomaron las fotos', 'L’Atlas des photos →': 'El Atlas →',
      'Essayez-les ensemble, sur votre mur.': 'Pruébalas juntas, en tu pared.', 'Un tirage gardé. Trouvez-lui un compagnon.': 'Una lámina guardada. Encuéntrale una compañera.',
      'Posez-les côte à côte, à l’échelle. Changez un cadre ou un format, puis ajoutez le tout au panier.': 'Colócalas lado a lado, a escala. Cambia un marco o un formato y añade el conjunto a la cesta.',
      'On vous propose un deuxième tirage du même sens : essayez le diptyque sur votre mur.': 'Te proponemos una segunda lámina con la misma orientación: prueba el díptico en tu pared.',
      'Les 5 derniers, côte à côte': 'Las 5 últimas, lado a lado', 'Voir la liste': 'Ver la lista', 'Voir le tirage': 'Ver la lámina',
      'Sommaire': 'Índice', 'Menu': 'Menú', 'Aucun tirage de cette collection avec ces filtres.': 'Ninguna lámina de esta colección coincide con estos filtros.',
      'Tous nos autres tirages': 'Todas las demás láminas'
    },
    /* Japonais : pas de majuscule, le glissement « Voir » du menu n'a pas de mot à montrer (un verbe se met
       après, pas avant) : la ligne glisse d'une espace et reste 「すべてのプリント」. */
    ja: {
      'Nos tirages': 'プリント一覧', 'Tous nos tirages': 'すべてのプリント', 'Voir': '', 'T': 'す', 't': 'す', 'ous nos tirages': 'べてのプリント',
      'Sélections': 'セレクション', 'Nouvelle sélection': '新着セレクション', 'Tirages limités': '限定エディション',
      'Horizontales': '横長', 'Verticales': '縦長', 'Nos collections': 'コレクション',
      'Les plus votés': '投票上位', '0 °C · Neige et sommets': '0°C・雪と峰々', 'Au fil de l’eau': '水辺にて', 'En ville': '街にて',
      'Participer': '参加する', 'Le vote': '投票', 'Choisissez la prochaine sélection.': '次のセレクションを選んでください。',
      'Sur candidature': '応募制', 'Devenir artiste de la galerie': 'ギャラリーのアーティストになる',
      'Vendez vos photos en tirages d’art, imprimés avec soin.': 'あなたの写真を、心を込めて刷り上げたアートプリントとして販売しませんか。',
      'Découvrir': '見つける', 'Découvrir, offrir et accrocher': '見つける・贈る・飾る', 'Nos artistes': 'アーティスト',
      'Le journal': 'ジャーナル', 'Atlas des photos': 'アトラス', 'Notre histoire': '私たちの物語',
      'Offrir et accrocher': '贈る・飾る', 'Offrir un tirage': 'プリントを贈る', 'Tester des images côte à côte': 'プリントを並べて試す',
      'Créer un compte': 'アカウントを作成する', 'Mes coups de cœur': 'お気に入り', 'Découvrir la suite de la page': 'ページの続きを見る',
      'Un diptyque, ou plus': '二連作、​またはそれ以上', 'Essayez-les sur votre mur.': 'お部屋の壁で​試してみて​ください。', 'Côte à côte': '並べて飾る',
      'Posez 2 à 5 tirages côte à côte, à l’échelle, et voyez-les sur votre mur.': '2〜5点のプリントを実際の縮尺で並べて、お部屋の壁で確かめられます。',
      'L’Atlas des photos : où les tirages ont été pris': 'アトラス：写真が撮影された場所', 'L’Atlas des photos →': 'アトラス →',
      'Essayez-les ensemble, sur votre mur.': 'お部屋の壁で、一緒に試してみてください。', 'Un tirage gardé. Trouvez-lui un compagnon.': '1点をお気に入りに保存しました。合わせる1点を見つけましょう。',
      'Posez-les côte à côte, à l’échelle. Changez un cadre ou un format, puis ajoutez le tout au panier.': '実際の縮尺で並べて、フレームやサイズを変えたら、まとめてカートに入れられます。',
      'On vous propose un deuxième tirage du même sens : essayez le diptyque sur votre mur.': '同じ向きのプリントをもう1点ご提案します。二連作をお部屋の壁で試してみてください。',
      'Les 5 derniers, côte à côte': '直近の5点を並べて', 'Voir la liste': 'リストを見る', 'Voir le tirage': 'プリントを見る',
      'Sommaire': '目次', 'Menu': 'メニュー', 'Aucun tirage de cette collection avec ces filtres.': 'この条件に合うプリントは、このコレクションにありません。',
      'Tous nos autres tirages': 'そのほかのプリント'
    }
  }[LANGUE] || {};
  function tr(s) {
    if (!EN) return s;
    if (Object.prototype.hasOwnProperty.call(TR_LANGUE, s)) return TR_LANGUE[s];
    return Object.prototype.hasOwnProperty.call(TR, s) ? TR[s] : s;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = tr(text);
    return n;
  }
  function headerH() {
    var h = document.querySelector('.section-header') || document.querySelector('sticky-header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }
  var modeFns = [];
  function onMode(fn) { modeFns.push(fn); }
  if (window.MutationObserver) {
    var lastOff = isOff();
    new MutationObserver(function () {
      var off = isOff();
      if (off === lastOff) return;
      lastOff = off;
      modeFns.forEach(function (fn) { safe(fn); });
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- 1. « Proposer mes photos » et l'espace artistes s'ouvrent dans un nouvel onglet ---------- */
  safe(function () {
    if (!has('bvf-a-newtab')) return;
    var SEL = 'a[href*="artists.bisourivage.fr"]';
    function mark() {
      var on = !isOff();
      document.querySelectorAll(SEL).forEach(function (a) {
        if (on) {
          if (!a.hasAttribute('data-bvf-target')) a.setAttribute('data-bvf-target', a.getAttribute('target') || '');
          a.setAttribute('target', '_blank');
          var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
          if (rel.indexOf('noopener') === -1) rel.push('noopener');
          a.setAttribute('rel', rel.join(' '));
        } else if (a.hasAttribute('data-bvf-target')) {
          var t = a.getAttribute('data-bvf-target');
          if (t) a.setAttribute('target', t); else a.removeAttribute('target');
          a.removeAttribute('data-bvf-target');
        }
      });
    }
    mark();
    window.addEventListener('load', mark);
    onMode(mark);
    window.__bvfMarkLinks = mark;
    /* Lien ajouté plus tard par un script du thème : on rattrape au clic */
    document.addEventListener('click', function (e) {
      if (isOff() || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest(SEL) : null;
      if (!a || a.getAttribute('target') === '_blank') return;
      e.preventDefault();
      window.open(a.href, '_blank', 'noopener');
    }, true);
  });

  /* ---------- 2. Menu tiroir : Nos tirages, Participer, Découvrir ----------
     17/10 (Max) : « Participer » (le vote, Proposer mes photos) remonte en 02, « Découvrir » passe en 03 ;
     sous « Tous nos tirages », des bulles (Nouvelle sélection, Tirages limités, Open edition, Horizontales,
     Verticales) et un dépliant « Collections » (Montagne, Mer, Ville…, snippet bvf-collections).
     Un appareil photo à la place de la flèche de « Proposer mes photos », une urne pour le vote (CSS).
     Rien n'est déplacé dans le thème : les blocs sont rangés par l'ordre CSS, « Avant » remet l'original. */
  safe(function () {
    if (!has('bvf-a-volet')) return;
    var panel = document.querySelector('#bisou-volet .bisou-volet__panel');
    if (!panel || panel.querySelector('.bvf-menu')) return;
    var top = panel.querySelector('.bisou-volet__top');
    var orig = panel.querySelectorAll('.bisou-volet__section a[href]');
    function find(test) {
      for (var i = 0; i < orig.length; i++) {
        var h = orig[i].getAttribute('href') || '';
        if (test(h, orig[i])) return orig[i];
      }
      return null;
    }
    function path(h) { return h.replace(/^https?:\/\/[^/]+/, '').replace(/^\/(en|fr|es|ja)(?=\/)/, ''); }
    /* Un lien : copie de l'original (adresse, pastille NEW), libellé posé ici */
    function link(test, label, opts) {
      opts = opts || {};
      var src = find(test);
      if (!src && !opts.href) return null;
      var a = el('a', 'bvf-menu__link' + (opts.lead ? ' is-lead' : '') + (opts.out ? ' bvf-menu__link--out' : ''));
      /* 25/10 (site anglais) : une adresse écrite ici (Journal, Atlas, édition ouverte) prend la langue de la page (ROOT) */
      a.href = src ? src.getAttribute('href') : (opts.href.charAt(0) === '/' && opts.href.charAt(1) !== '/' ? ROOT + opts.href : opts.href);
      a.appendChild(el('span', 'bvf-menu__txt', label));
      if (src && opts.badge !== false) {
        var b = src.querySelector('.bisou-volet__badge');
        if (b && /new/i.test(b.textContent)) {
          /* 21/10 (revue téléphone, défaut 14) : en français, la pastille dit « NOUVEAU », plus « NEW » */
          var nb = b.cloneNode(true);
          if (/^fr/i.test(root.lang || 'fr')) {
            [].forEach.call(nb.childNodes, function (n) { if (n.nodeType === 3 && /^\s*new\s*$/i.test(n.nodeValue)) n.nodeValue = 'NOUVEAU'; });
          }
          a.appendChild(nb);
        }
      }
      if (opts.out) { a.target = '_blank'; a.rel = 'noopener'; }
      return a;
    }
    function group(num, label, items) {
      var g = el('div', 'bvf-menu__group');
      var l = el('p', 'bvf-menu__label');
      l.appendChild(el('span', 'bvf-menu__num', num));
      l.appendChild(el('span', null, label));
      g.appendChild(l);
      items.forEach(function (it) { if (it) g.appendChild(it); });
      return g;
    }
    var is = function (want) { return function (h) { return path(h) === want; }; };

    var ICONS = {
      artistes: '<path d="M12 12.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z"/><path d="M5 19.5c1.1-3.2 3.8-4.9 7-4.9s5.9 1.7 7 4.9"/>',
      carte: '<circle cx="12" cy="12" r="8.2"/><path d="M3.8 12h16.4M12 3.8c2.3 2.3 3.4 5 3.4 8.2s-1.1 5.9-3.4 8.2c-2.3-2.3-3.4-5-3.4-8.2S9.7 6.1 12 3.8Z"/>',
      journal: '<path d="M6 4.5h9.5L19 8v11.5H6z"/><path d="M15.5 4.5V8H19M9 12h7M9 15.5h5"/>',
      cote: '<rect x="2.5" y="7" width="5.4" height="10" rx=".6"/><rect x="9.3" y="7" width="5.4" height="10" rx=".6"/><rect x="16.1" y="7" width="5.4" height="10" rx=".6"/>',
      coeur: '<path d="M12 19.3s-7-4.3-7-9.4A3.9 3.9 0 0 1 12 7.6a3.9 3.9 0 0 1 7 2.3c0 5.1-7 9.4-7 9.4Z"/>',
      livre: '<path d="M12 6.8c-1.9-1.4-4.4-1.9-7.5-1.6v12.6c3.1-.3 5.6.2 7.5 1.6 1.9-1.4 4.4-1.9 7.5-1.6V5.2c-3.1-.3-5.6.2-7.5 1.6Z"/><path d="M12 6.8v12.6"/>',
      cadeau: '<rect x="4" y="9" width="16" height="11" rx="1"/><path d="M4 12.5h16M12 9v11M12 9c-1.7-3.6-6-3.4-4.9-.6.5 1.1 4.9.6 4.9.6Zm0 0c1.7-3.6 6-3.4 4.9-.6-.5 1.1-4.9.6-4.9.6Z"/>',
      tshirt: '<path d="M9 4.5 4.5 7l1.6 3.6 2-.9V19.5h7.8V9.7l2 .9L19.5 7 15 4.5c-.5 1.3-1.6 2.1-3 2.1s-2.5-.8-3-2.1Z"/>',
      urne: '<path d="M4.5 12.5h15v6.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1z"/><path d="M8.5 12.5V4.5h7v8"/><path d="m10.3 8.6 1.3 1.3 2.2-2.4"/>'
    };
    function withIcon(a, key) {
      if (!a) return null;
      a.classList.add('bvf-menu__item');
      a.insertAdjacentHTML('afterbegin', '<svg class="bvf-menu__ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[key] || '') + '</svg>');
      return a;
    }
    function big(a) { if (a) a.classList.add('bvf-menu__big'); return a; }
    function chips(list) {
      var row = el('div', 'bvf-menu__chips');
      list.forEach(function (c) { if (c) { c.classList.add('bvf-menu__chip'); row.appendChild(c); } });
      return row.children.length ? row : null;
    }
    var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
    var here = path(location.pathname);
    var hereSujet = null;
    try { hereSujet = new URLSearchParams(location.search).get('sujet'); } catch (e) {}
    function sub(href, label, count, sujet) {
      var a = el('a', 'bvf-menu__link bvf-menu__subl');
      a.href = ROOT + href;
      /* 21/10 (v4-6) : chaque collection a sa couleur légère (CSS, bisou-alt-plus.css § 2 ter) */
      if (sujet) a.setAttribute('data-sujet', sujet);
      a.appendChild(el('span', 'bvf-menu__txt', label));
      if (count) a.appendChild(el('span', 'bvf-menu__cnt', String(count)));
      var on = sujet ? (here === '/collections/all' && hereSujet === sujet) : here === href;
      if (on) { a.classList.add('is-on'); a.setAttribute('aria-current', 'page'); }
      return a;
    }
    function fold(label, items) {
      var d = el('details', 'bvf-menu__fold');
      var s = el('summary', 'bvf-menu__sum');
      var row = el('span', 'bvf-menu__link bvf-menu__big');
      row.appendChild(el('span', 'bvf-menu__txt', label));
      var chev = el('span', 'bvf-menu__chev');
      chev.setAttribute('aria-hidden', 'true');
      row.appendChild(chev);
      s.appendChild(row);
      d.appendChild(s);
      var box = el('div', 'bvf-menu__sub');
      items.forEach(function (a) { box.appendChild(a); if (a.classList.contains('is-on')) d.open = true; });
      d.appendChild(box);
      return d;
    }
    /* Les collections à thème (bvf-collections) ; sans elles, l'ancien dépliant */
    var coll = null;
    try { var cj = document.getElementById('bvf-coll'); if (cj) coll = JSON.parse(cj.textContent); } catch (e) { coll = null; }
    var collItems;
    if (coll && coll.g && coll.g.length) {
      collItems = coll.g.filter(function (g) { return g.c > 0; }).map(function (g) {
        return sub('/collections/all?sujet=' + encodeURIComponent(g.k), g.n, g.c, g.k);
      });
    } else {
      collItems = [
        sub('/collections/top-voted', 'Les plus votés'),
        sub('/collections/all/sujet-neige', '0 °C · Neige et sommets'),
        sub('/collections/all/sujet-eau', 'Au fil de l’eau'),
        sub('/collections/all/sujet-ville', 'En ville')
      ];
    }
    /* « Open edition » n'apparaît que si une édition ouverte est en vente (aucune au 17/10) */
    var openChip = (coll && coll.o > 0) ? link(function () { return false; }, 'Open edition', { href: '/collections/all?edition=open' }) : null;

    /* 20/10 (R6 de Max, « on s'y perd ») : 01 se lit d'un coup d'œil — tous les tirages, puis les sélections, puis
       les collections, chacune sous son petit titre ; les collections sont visibles tout de suite, plus de dépliant. */
    function subLabel(txt) { return el('p', 'bvf-menu__sublabel', txt); }
    var menu = el('nav', 'bvf-menu');
    menu.setAttribute('data-bvf', 'menu');
    menu.setAttribute('aria-label', tr('Menu'));
    var collChips = chips(collItems);
    var selChips = chips([
      link(is('/collections/new-arrivals'), 'Nouvelle sélection', { badge: false }),
      link(function (h) { return /edition=limited/.test(h); }, 'Tirages limités', { badge: false }),
      openChip,
      link(function (h) { return /orient=h/.test(h); }, 'Horizontales'),
      link(function (h) { return /orient=v/.test(h); }, 'Verticales')
    ]);
    /* 22/10 (v7-19 de Max) : au survol, « Voir tous nos tirages ».
       23/10 (Max, « un glissement léger vers la droite avec le mot voir qui apparaît ») : « Voir » attend à gauche,
       invisible ; au survol, le libellé glisse vers la droite de la largeur de « Voir », qui apparaît, et le T devient
       t (bisou-alt-plus.css § 2 quater). Que des transform et des opacités : la ligne ne change pas de largeur. */
    var leadAll = link(is('/collections/all'), 'Tous nos tirages', { lead: true });
    var leadTxt = leadAll && leadAll.querySelector('.bvf-menu__txt');
    if (leadTxt) {
      leadTxt.textContent = '';
      leadTxt.classList.add('bvf-menu__swap');
      var leadVoir = el('span', 'bvf-menu__swap-voir', 'Voir');
      leadVoir.setAttribute('aria-hidden', 'true');
      leadTxt.appendChild(leadVoir);
      var leadRest = el('span', 'bvf-menu__swap-rest');
      var leadCap = el('span', 'bvf-menu__swap-cap');
      leadCap.appendChild(el('span', 'bvf-menu__swap-up', 'T'));
      var leadLow = el('span', 'bvf-menu__swap-low', 't');
      leadLow.setAttribute('aria-hidden', 'true');
      leadCap.appendChild(leadLow);
      leadRest.appendChild(leadCap);
      leadRest.appendChild(document.createTextNode(tr('ous nos tirages')));
      leadTxt.appendChild(leadRest);
      /* Le pas du glissement = « Voir », une espace, moins ce que le t a de moins que le T (le t se cale à droite
         de la case du T) ; mesuré au survol, police chargée */
      var leadStep = function () {
        var w = leadVoir.getBoundingClientRect().width;
        if (!w) return;
        var fs = parseFloat(getComputedStyle(leadTxt).fontSize) || 16;
        var up = leadCap.firstChild.getBoundingClientRect().width, low = leadLow.getBoundingClientRect().width;
        leadTxt.style.setProperty('--bvf-voir', (w + fs * 0.27 - Math.max(0, up - low)).toFixed(1) + 'px');
      };
      leadAll.addEventListener('pointerenter', leadStep);
      leadAll.addEventListener('focus', leadStep);
    }
    menu.appendChild(group('01', 'Nos tirages', [
      big(leadAll),
      selChips ? subLabel('Sélections') : null,
      selChips,
      collChips ? subLabel('Nos collections') : null,
      collChips
    ]));
    var g2 = group('02', 'Participer', []);
    g2.classList.add('bvf-menu__group--last');
    menu.appendChild(g2);

    /* 02 : le bouton du vote est celui du thème (ses textes suivent la phase du vote) ; puis l'appel aux photographes.
       20/10 (R6) : deux cartes qui appellent — un surtitre (les mots du pied de page), le titre, une ligne. */
    var voteCta = panel.querySelector('.bisou-volet__actions .bisou-volet__vote-cta');
    if (voteCta && !voteCta.querySelector('.bvf-menu__eyebrow')) {
      /* 21/10 (v4-6, « un petit logo ») : une urne devant « Le vote » ; la carte grandit dans le CSS (bisou-alt-plus.css § 2 ter) */
      var voteEye = el('span', 'bvf-menu__eyebrow', 'Le vote');
      voteEye.insertAdjacentHTML('afterbegin', '<svg class="bvf-menu__eyebrow-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + ICONS.urne + '</svg>');
      voteCta.insertBefore(voteEye, voteCta.firstChild);
      voteCta.appendChild(el('span', 'bvf-menu__promise', 'Choisissez la prochaine sélection.'));
    }
    var act = el('div', 'bvf-menu-act');
    act.setAttribute('data-bvf', 'menu-act');
    var propose = link(function (h) { return /artists\.bisourivage\.fr/.test(h); }, 'Devenir artiste de la galerie', { out: true, badge: false });
    if (propose) {
      propose.classList.add('bvf-menu__pill', 'bvf-menu__link--cam');
      propose.insertBefore(el('span', 'bvf-menu__eyebrow', 'Sur candidature'), propose.firstChild);
      propose.appendChild(el('span', 'bvf-menu__promise', 'Vendez vos photos en tirages d’art, imprimés avec soin.'));
      act.appendChild(propose);
    }

    /* 20/10 (R6) : « Découvrir » était trop long ; il garde l'univers, une quatrième famille prend le reste. */
    var menuB = el('nav', 'bvf-menu bvf-menu--b');
    menuB.setAttribute('data-bvf', 'menu-b');
    menuB.setAttribute('aria-label', tr('Découvrir, offrir et accrocher'));
    /* 02/11 (Max, 13 h 10 : « y'a plus le bouton tshirt … dans le menu on the side ») : le t-shirt, de nouveau en stock,
       revient en tête de « Découvrir », à sa place de la barre du haut (avant « Nos artistes »), avec la pastille du thème. */
    var teeTest = function (h) { return h.indexOf('/products/t-shirt') !== -1; };
    var teeSrc = find(teeTest);
    var teeTxt = teeSrc && teeSrc.firstChild && teeSrc.firstChild.nodeType === 3 ? teeSrc.firstChild.nodeValue.trim() : '';
    var tee = withIcon(link(teeTest, teeTxt || 'T-shirts', { badge: false }), 'tshirt');
    var teeBadge = teeSrc && teeSrc.querySelector('.bisou-volet__badge');
    if (tee && teeBadge) tee.appendChild(teeBadge.cloneNode(true));
    menuB.appendChild(group('03', 'Découvrir', [
      tee,
      withIcon(link(is('/pages/artiste'), 'Nos artistes'), 'artistes'),
      withIcon(link(function () { return false; }, 'Le journal', { href: '/blogs/journal' }), 'journal'),
      /* 21/10 (v4-6, décision 10) : « Atlas des photos » à la place de « La carte des photos » */
      withIcon(link(function () { return false; }, 'Atlas des photos', { href: '/collections/all?view=carte' }), 'carte'),
      withIcon(link(is('/pages/notre-histoire'), 'Notre histoire'), 'livre')
    ]));
    /* 20/10 au soir (v3-8) : le t-shirt, épuisé, sort du menu ; « Composer mon mur » devient « Tirages côte à côte »
       (Max, 22 h 45 : deux ou trois œuvres l'une à côté de l'autre). L'adresse de la page ne change pas.
       21/10, 14 h 45 (Max) : dans le menu, « Créer un ensemble » ; la page garde « Côte à côte ».
       23/10 (Max) : « Créer un ensemble » devient « Tester des images côte à côte ». */
    menuB.appendChild(group('04', 'Offrir et accrocher', [
      withIcon(link(is('/products/gift-card'), 'Offrir un tirage', { badge: false }), 'cadeau'),
      withIcon(link(function (h) { return /framed-wall-planner/.test(h); }, 'Tester des images côte à côte'), 'cote')
    ]));

    /* Mon compte et la liste d'envies : deux tuiles (avant le 20/10 : deux liens soulignés) */
    var end = el('div', 'bvf-menu-end');
    end.setAttribute('data-bvf', 'menu-end');
    var small = el('div', 'bvf-menu__small bvf-menu__tiles');
    function tile(href, label, svg) {
      var t = el('a', 'bvf-menu__tile');
      t.href = href;
      t.insertAdjacentHTML('afterbegin', '<svg class="bvf-menu__tile-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + svg + '</svg>');
      t.appendChild(el('span', 'bvf-menu__tile-txt', label));
      return t;
    }
    var join = panel.querySelector('.bisou-volet__join');
    if (join) small.appendChild(tile(join.getAttribute('href'), (join.textContent || '').trim() || 'Créer un compte', ICONS.artistes));
    /* 25/10 (site-vendeur) : la tuile disait « Ma wishlist » ; elle prend le libellé du lien du thème (nav.wishlist),
       le même mot que le cœur de l'en-tête et la page, dans chaque langue. */
    var wish = find(function (h) { return /wishlist/.test(h); });
    if (wish) small.appendChild(tile(wish.getAttribute('href'), (wish.textContent || '').trim() || 'Mes coups de cœur', ICONS.coeur));
    /* 25/10 (site-vendeur) : livraison et retours, formats, questions, contact n'étaient qu'au pied de page, au bout
       de la page et d'un accordéon. Le menu reprend la colonne « Aide » du pied telle quelle (titre, adresses et
       libellés, déjà traduits) : une seule source, rien d'écrit ici. Sans cette colonne, rien n'apparaît. */
    var aideA = document.querySelector('.bisou-footer a.bisou-footer__link[href$="/pages/livraison-retours"]');
    var aideCol = aideA && aideA.closest('.bisou-footer__col');
    var aideHead = aideCol && aideCol.querySelector('.bisou-footer__col-head');
    if (aideHead && (aideHead.textContent || '').trim()) {
      var aideChips = chips([].map.call(aideCol.querySelectorAll('.bisou-footer__col-list a.bisou-footer__link[href]'), function (s) {
        var a = document.createElement('a');
        a.className = 'bvf-menu__link';
        a.href = s.getAttribute('href');
        var t = document.createElement('span');
        t.className = 'bvf-menu__txt';
        t.textContent = (s.textContent || '').trim();
        a.appendChild(t);
        return a;
      }));
      if (aideChips) {
        var aide = group('05', aideHead.textContent.trim(), [aideChips]);
        aide.classList.add('bvf-menu__group--aide');
        end.appendChild(aide);
      }
    }
    if (small.children.length) end.appendChild(small);

    /* 21/10 (revue téléphone, défaut 14) : « Langue » n'affichait qu'un drapeau ; le nom de la langue à côté,
       repris de la liste du thème (Français, English). Caché en « Avant » (CSS). */
    var langBtn = document.querySelector('#bisou-volet .localization-selector--flag');
    var langForm = langBtn && langBtn.closest ? langBtn.closest('form') : null;
    var langCur = langForm ? langForm.querySelector('a[aria-current="true"]') : null;
    if (langBtn && langCur && !langBtn.querySelector('.bvf-menu__lang')) {
      var langName = '';
      [].forEach.call(langCur.children, function (s) { if (!langName && !s.className && s.textContent.trim()) langName = s.textContent.trim(); });
      var langFlag = langBtn.querySelector('.localization-flag');
      if (langName && langFlag) {
        var langTxt = el('span', 'bvf-menu__lang', langName);
        langTxt.setAttribute('aria-hidden', 'true');
        langFlag.parentNode.insertBefore(langTxt, langFlag.nextSibling);
      }
    }

    if (top && top.nextSibling) panel.insertBefore(menu, top.nextSibling); else panel.insertBefore(menu, panel.firstChild);
    panel.appendChild(act);
    panel.appendChild(menuB);
    panel.appendChild(end);
    root.classList.add('bvf-menu-ready');
    if (window.__bvfMarkLinks) window.__bvfMarkLinks();
  });

  /* ---------- 3. Accueil : la suite dépasse en bas du premier écran ---------- */
  safe(function () {
    if (!has('bvf-a-hero')) return;
    var sec = document.querySelector('.shopify-section[id$="__bisou-hero"]');
    var hero = sec && sec.querySelector('.bisou-hero');
    if (!hero) return;
    var next = sec.nextElementSibling;
    while (next && !(next.classList && next.classList.contains('shopify-section'))) next = next.nextElementSibling;
    if (!next) return;
    var svh = !!(window.CSS && CSS.supports && CSS.supports('height', '100svh'));
    var cue = el('button', 'bvf-cue');
    cue.type = 'button';
    cue.setAttribute('data-bvf', 'cue');
    cue.setAttribute('aria-label', tr('Découvrir la suite de la page'));
    cue.appendChild(el('span', null, 'Découvrir'));
    cue.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>');
    hero.appendChild(cue);
    var lastW = 0;
    function peek() {
      var vh = window.innerHeight || root.clientHeight;
      return Math.round(Math.min(124, Math.max(76, vh * 0.12)));
    }
    function apply(force) {
      if (!force && window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      if (isOff()) { next.style.removeProperty('margin-top'); return; }
      var p = peek();
      var vh = window.innerHeight || root.clientHeight;
      next.style.setProperty('margin-top', svh ? 'calc(100svh - ' + p + 'px)' : (vh - p) + 'px', 'important');
      cue.style.top = svh ? 'calc(100svh - ' + (p + 74) + 'px)' : (vh - p - 74) + 'px';
      mesure();
    }
    /* La flèche rebondit sans fin, et le navigateur recalcule la page à chaque image tant qu'elle tourne.
       La photo est fixe : dès qu'on descend un peu, la page la recouvre. On met alors le rebond en pause,
       il reprend quand on remonte (marge de 12 px : le rebond et l'ombre). */
    var arrow = cue.querySelector('svg'), lim = Infinity, calme = false;
    function regle() {
      var c = window.pageYOffset > lim;
      if (c === calme) return;
      calme = c;
      arrow.style.animationPlayState = c ? 'paused' : '';
    }
    function mesure() {
      var a = arrow.getBoundingClientRect(), y = window.pageYOffset;
      if (!a.height) { lim = Infinity; regle(); return; }
      lim = getComputedStyle(hero).position === 'fixed'
        ? next.getBoundingClientRect().top + y - a.top + 12
        : a.bottom + y + 12;
      regle();
    }
    apply(true);
    window.addEventListener('resize', function () { apply(false); });
    window.addEventListener('scroll', regle, { passive: true });
    window.addEventListener('load', mesure);
    onMode(function () { apply(true); });
    cue.addEventListener('click', function () {
      var y = next.getBoundingClientRect().top + window.pageYOffset - headerH();
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });
  });

  /* ---------- 4. Simulateur de mur : le plein écran garde « Mon mur » ----------
     Le simulateur passait en vue « Centré » pour le plein écran : le mur défini disparaissait,
     les cadres grossissaient seuls. Ici on agrandit la vue telle quelle, à l'échelle du mur. */
  safe(function () {
    if (!has('bvf-a-planner')) return;
    var P = document.getElementById('BRPlanner');
    if (!P) return;
    function realOn() { return !!P.querySelector('#brpWallMode [data-wall-mode="real"].on'); }
    function setFs(on) {
      P.classList.toggle('br-fs', on);
      P.classList.remove('br-preview-large');
      var b = P.querySelector('#brpFs');
      if (b) {
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        var PL = (window.BRPlanner && window.BRPlanner.lang) || {};
        b.setAttribute('aria-label', on ? (PL.fullscreen_close || 'Fermer le plein écran') : (PL.fullscreen || 'Plein écran'));
      }
      P.querySelectorAll('#brpPreviewModes [data-preview]').forEach(function (m) {
        m.classList.toggle('on', m.getAttribute('data-preview') === (on ? 'fullscreen' : 'normal'));
      });
      window.dispatchEvent(new Event('resize'));
    }
    document.addEventListener('click', function (e) {
      if (isOff() || !e.target.closest) return;
      var t = e.target.closest('#brpFs, #brpPreviewModes [data-preview="fullscreen"]');
      if (!t || !P.contains(t)) return;
      var fs = P.classList.contains('br-fs');
      /* Sortie du plein écran ou vue « Centré » : le simulateur fait comme d'habitude */
      if (!fs && !realOn()) return;
      if (fs && !P.hasAttribute('data-bvf-fs')) return;
      e.preventDefault();
      e.stopPropagation();
      if (fs) { P.removeAttribute('data-bvf-fs'); setFs(false); } else { P.setAttribute('data-bvf-fs', ''); setFs(true); }
    }, true);
    /* Échap ou autre sortie gérée par le simulateur : on oublie notre marque */
    new MutationObserver(function () {
      if (!P.classList.contains('br-fs')) P.removeAttribute('data-bvf-fs');
    }).observe(P, { attributes: true, attributeFilter: ['class'] });
  });

  /* ---------- 5. Pages légales : sommaire ---------- */
  safe(function () {
    if (!has('bvf-a-policy')) return;
    var box = document.querySelector('.shopify-policy__container');
    var body = box && box.querySelector('.shopify-policy__body');
    var rte = body && (body.querySelector('.rte') || body);
    if (!rte) return;
    var hs = rte.querySelectorAll('h2');
    if (hs.length < 3) return;
    var toc = el('details', 'bvf-pol__toc');
    toc.setAttribute('data-bvf', 'toc');
    toc.appendChild(el('summary', null, tr('Sommaire')));
    var ol = el('ol');
    var links = [];
    var used = {};
    hs.forEach(function (h, i) {
      if (!h.id) {
        var base = 'pol-' + (h.textContent || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        var id = base || 'pol-' + (i + 1);
        while (used[id] || document.getElementById(id)) id += '-' + (i + 1);
        used[id] = true;
        h.id = id;
      }
      var li = el('li');
      var a = el('a', null, (h.textContent || '').trim());
      a.href = '#' + h.id;
      li.appendChild(a);
      ol.appendChild(li);
      links.push(a);
    });
    toc.appendChild(ol);
    box.insertBefore(toc, body);
    var mq = window.matchMedia('(min-width: 990px)');
    function sync() { toc.open = mq.matches; }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
    ol.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - headerH() - 24, behavior: 'smooth' });
      if (!mq.matches) toc.open = false;
      if (history.replaceState) history.replaceState(null, '', '#' + t.id);
    });
    /* La rubrique lue est marquée dans le sommaire */
    var ticking = false;
    function mark() {
      ticking = false;
      var y = headerH() + 60, cur = 0;
      hs.forEach(function (h, i) { if (h.getBoundingClientRect().top <= y) cur = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === cur); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; setTimeout(mark, 60); } }, { passive: true });
    mark();
  });

  /* ---------- 6. Collections : la vue « Carte » à côté des vues de la grille ----------
     15/10 (retour Max) : un globe avec un seul point, au milieu des formations de points de « Vue »,
     se lisait « un tirage par ligne ». Le lien sort du groupe, avec un repère et le mot « Carte ». */
  safe(function () {
    if (!has('bvf-a-atlas')) return;
    /* 25/10 (site anglais) : hors français, le lien garde la langue (/en/collections/all…). L'adresse
       vient du réglage de la section (data-bvf-atlas, toujours rempli) : la langue s'ajoute devant. */
    var lang = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
    var url = root.getAttribute('data-bvf-atlas') || '/collections/all?view=carte';
    if (lang && url.charAt(0) === '/' && url.charAt(1) !== '/' && url.indexOf(lang + '/') !== 0) url = lang + url;
    function add() {
      var box = document.querySelector('.bisou-toolbar__view');
      if (!box || !box.parentNode || box.parentNode.querySelector('.bvf-view-carte')) return;
      var a = el('a', 'bvf-view-carte');
      a.href = url;
      a.title = tr('L’Atlas des photos : où les tirages ont été pris');
      a.setAttribute('data-bvf', 'atlas');
      a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6s-6.2-5.9-6.2-10.7A6.2 6.2 0 0 1 12 3.7a6.2 6.2 0 0 1 6.2 6.2c0 4.8-6.2 10.7-6.2 10.7Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="12" cy="9.9" r="2.2" fill="none" stroke="currentColor" stroke-width="1.5"/></svg><span>' + selon('Atlas', 'Atlas', 'Atlas', 'アトラス') + '</span>';
      box.parentNode.insertBefore(a, box.nextSibling);
      /* Téléphone : « Vue » n'existe pas ; une bulle sous les filtres, dans le style des bulles de collection */
      var nav = document.querySelector('.bisou-colnav');
      if (nav && !nav.querySelector('.bvf-atlas-bubbles')) {
        var row = el('div', 'bisou-colnav__bubbles bvf-atlas-bubbles');
        row.setAttribute('data-bvf', 'atlas-bubble');
        var b = el('a', 'bisou-colnav__bubble', tr('L’Atlas des photos →'));
        b.href = url;
        row.appendChild(b);
        nav.appendChild(row);
      }
    }
    add();
    /* La barre peut être re-rendue par l'éditeur de thème ou les facettes */
    document.addEventListener('shopify:section:load', add);
  });

  /* ---------- 6 ter. La visite : pages vues, fiche d'un tirage vue (29/10, c29u) ----------
     Max (29/10) : « un diptyque ou plus » attend que la personne ait fait un peu le tour du site. Il se montre à
     partir de la 3e page vue, ou dès qu'un tirage a été ouvert. localStorage br_tour_v1 = { p: pages vues, f: 1 si une
     fiche } ; sans stockage, la bande reste cachée. La grille lit la même clé avant la première peinture
     (bisou-collection-grid, place de la bande) : les deux comptent la page en cours. */
  var TOUR = { p: 0, f: 0, ok: false };
  safe(function () {
    var t = null;
    try { t = JSON.parse(localStorage.getItem('br_tour_v1') || 'null'); } catch (e) { t = null; }
    var p = ((t && +t.p) || 0) + 1, fi = (t && t.f) || /\/products\//.test(location.pathname) ? 1 : 0;
    try { localStorage.setItem('br_tour_v1', JSON.stringify({ p: Math.min(p, 99), f: fi })); } catch (e) { return; }
    TOUR = { p: p, f: fi, ok: p >= 3 || fi === 1 };
  });

  /* ---------- 6 bis. Collections : « Composer un diptyque, ou plus », visible et montré ----------
     15/10 (retour Max). Une bande sous la barre d'outils : deux tirages de la page posés côte à côte,
     une phrase, et le lien qui les ouvre dans « Composer mon mur ».
     26/10 : la grille réserve sa place (.bvf-compose-place, bisou-collection-grid) ; la bande la prend, ou la place s'en va. */
  safe(function () {
    function unplace() { var p = document.querySelector('.bvf-compose-place'); if (p && p.parentNode) p.parentNode.removeChild(p); }
    if (!has('bvf-a-planner')) return unplace();
    if (!TOUR.ok) return unplace();
    /* 25/10 (site anglais) : hors français, le lien garde la langue (/en/pages/…) */
    var PLANNER = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '') + '/pages/framed-wall-planner';
    /* 21/10 : sur une collection à thème (/collections/all?sujet=…), seulement ses tirages. Le tri de la
       grille (§ 21) passe après cette partie : sans ce filtre, le diptyque prenait ceux d'autres collections. */
    function sujetKeep() {
      if (!has('bvf-a-coll') || isOff()) return null;
      var key = null, data = null;
      try { key = new URLSearchParams(location.search).get('sujet'); } catch (e) { key = null; }
      try { var cj = document.getElementById('bvf-coll'); if (cj) data = JSON.parse(cj.textContent); } catch (e) { data = null; }
      if (!key || !data || !data.p || !(data.g || []).some(function (x) { return x.k === key; })) return null;
      return function (h) { var ks = data.p[h]; return !!ks && (' ' + ks + ' ').indexOf(' ' + key + ' ') > -1; };
    }
    function cards() {
      var out = [], seen = {}, keep = sujetKeep();
      document.querySelectorAll('#ProductGridContainer .card-wrapper').forEach(function (c) {
        var a = c.querySelector('a[href*="/products/"]');
        var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        var im = c.querySelector('.card__media img');
        if (!m || seen[m[1]] || !im) return;
        if (keep && !keep(decodeURIComponent(m[1]))) return;
        seen[m[1]] = true;
        var w = Number(im.getAttribute('width')) || im.naturalWidth || 0;
        var h = Number(im.getAttribute('height')) || im.naturalHeight || 0;
        out.push({ h: m[1], src: im.currentSrc || im.getAttribute('src') || '', o: w && h ? (w > h ? 'h' : 'v') : '' });
      });
      return out;
    }
    function thumb(src) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=360') : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=360';
    }
    function build() {
      if (document.querySelector('[data-bvf="compose"]')) return unplace();
      var grid = document.getElementById('ProductGridContainer');
      if (!grid || !grid.parentNode) return unplace();
      var list = cards();
      if (list.length < 2) return unplace();
      var a = list[0];
      var b = list.slice(1).filter(function (x) { return x.o && x.o === a.o; })[0] || list[1];
      var band = el('div', 'bvf-compose');
      band.setAttribute('data-bvf', 'compose');
      var wall = el('div', 'bvf-compose__wall');
      wall.setAttribute('aria-hidden', 'true');
      [a, b].forEach(function (it) {
        var f = el('span', 'bvf-compose__frame');
        var im = el('img');
        im.alt = ''; im.decoding = 'async'; im.loading = 'lazy';
        im.src = thumb(it.src);
        f.appendChild(im);
        wall.appendChild(f);
      });
      var txt = el('div', 'bvf-compose__txt');
      txt.appendChild(el('p', 'bvf-compose__t', tr('Un diptyque, ou plus')));
      /* 17/10 : au téléphone, une ligne courte à la place de la phrase (la bande tient sur une rangée) */
      var sub = el('p', 'bvf-compose__s');
      sub.appendChild(el('span', 'bvf-compose__long', tr('Posez 2 à 5 tirages côte à côte, à l’échelle, et voyez-les sur votre mur.')));
      sub.appendChild(el('span', 'bvf-compose__short', tr('Essayez-les sur votre mur.')));
      txt.appendChild(sub);
      var go = el('a', 'bvf-compose__btn');
      go.href = PLANNER + '?ids=' + encodeURIComponent(a.h + ',' + b.h);
      go.innerHTML = '<span>' + tr('Côte à côte') + '</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
      band.appendChild(wall);
      band.appendChild(txt);
      band.appendChild(go);
      var place = document.querySelector('.bvf-compose-place');
      var bar = document.querySelector('.bisou-toolbar');
      if (place && place.parentNode) place.parentNode.replaceChild(band, place);
      else if (bar && bar.parentNode === grid.parentNode) bar.parentNode.insertBefore(band, bar.nextSibling);
      else grid.parentNode.insertBefore(band, grid);
    }
    build();
    document.addEventListener('shopify:section:load', build);
  });

  /* ---------- 7. T-shirt : affiché épuisé (la précommande est close) ----------
     Le CSS masque les rangées d'achat ; ici on pose le mot qui le dit, sous le titre. */
  safe(function () {
    if (!has('bvf-a-tshirt')) return;
    var tpl = document.getElementById('bvf-tpl-tsout');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    function place() {
      if (document.querySelector('[data-bvf="tsout"]')) return;
      var row = document.querySelector('.rv5-cartel-row');
      if (!row || !row.parentNode) return;
      row.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), row.nextSibling);
    }
    place();
    document.addEventListener('shopify:section:load', place);
    window.addEventListener('load', place);
  });

  /* ---------- 9. Wishlist : un haut de page qui donne envie ----------
     15/10 (retour Max : « le texte et le bouton ne donnent pas envie »). Les tirages gardés, posés sur un mur,
     une phrase, et un bouton qui les ouvre tous dans « Composer mon mur » (deux à cinq). */
  safe(function () {
    if (!has('bvf-a-planner')) return;
    var body = document.querySelector('.bwl__body');
    var intro = body && body.querySelector('.bwl__intro');
    if (!body || !intro) return;
    var PLANNER = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '') + '/pages/framed-wall-planner';
    var hero = null;
    function items() {
      var list = [];
      try {
        if (window.BisouWishlist && typeof window.BisouWishlist.read === 'function') list = window.BisouWishlist.read();
        else { var d = JSON.parse(localStorage.getItem('br_wishlist_v1')); list = d && Array.isArray(d.items) ? d.items : []; }
      } catch (e) { list = []; }
      return list.slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); }).filter(function (i) { return i && i.h; });
    }
    function img(src) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=420') : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=420';
    }
    function render() {
      var list = items();
      /* Une liste partagée (?items=…) garde l'écran d'origine : ce ne sont pas les tirages du visiteur */
      if (!list.length || /[?&](items|shared|share)=/.test(location.search)) {
        if (hero) { hero.remove(); hero = null; }
        root.classList.remove('bvf-wlh-on');
        return;
      }
      var n = list.length, pick = list.slice(0, 3);
      if (!hero) {
        hero = el('section', 'bvf-wlh');
        hero.setAttribute('data-bvf', 'wl-hero');
        intro.parentNode.insertBefore(hero, intro);
      }
      hero.innerHTML = '';
      var wall = el('div', 'bvf-wlh__wall');
      wall.setAttribute('aria-hidden', 'true');
      pick.forEach(function (it) {
        if (!it.img) return;
        var f = el('span', 'bvf-wlh__frame');
        var im = el('img');
        im.alt = ''; im.decoding = 'async';
        im.src = img(it.img);
        f.appendChild(im);
        wall.appendChild(f);
      });
      var txt = el('div', 'bvf-wlh__txt');
      txt.appendChild(el('p', 'bvf-wlh__k', selon('Vos coups de cœur · ' + n + (n > 1 ? ' tirages' : ' tirage'), 'Your favourites · ' + n + (n > 1 ? ' prints' : ' print'), 'Tu lista de deseos · ' + n + (n > 1 ? ' láminas' : ' lámina'), 'お気に入り・' + n + '点')));
      txt.appendChild(el('h2', 'bvf-wlh__t', tr(n > 1 ? 'Essayez-les ensemble, sur votre mur.' : 'Un tirage gardé. Trouvez-lui un compagnon.')));
      txt.appendChild(el('p', 'bvf-wlh__s', tr(n > 1
        ? 'Posez-les côte à côte, à l’échelle. Changez un cadre ou un format, puis ajoutez le tout au panier.'
        : 'On vous propose un deuxième tirage du même sens : essayez le diptyque sur votre mur.')));
      var acts = el('div', 'bvf-wlh__acts');
      var go = el('a', 'bvf-wlh__btn');
      var ids = list.slice(0, 5).map(function (i) { return i.h; }).join(',');
      go.href = PLANNER + '?ids=' + encodeURIComponent(ids);
      go.innerHTML = '<span>' + (n > 1 ? (n > 5 ? tr('Les 5 derniers, côte à côte') : selon('Ces ' + n + ' tirages, côte à côte', 'These ' + n + ' prints, side by side', 'Estas ' + n + ' láminas, lado a lado', 'この' + n + '点を並べて')) : tr('Côte à côte')) + '</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
      acts.appendChild(go);
      var see = el('button', 'bvf-wlh__see', tr(n > 1 ? 'Voir la liste' : 'Voir le tirage'));
      see.type = 'button';
      see.addEventListener('click', function () {
        var g = body.querySelector('[data-bwl-toolbar]') || body.querySelector('[data-bwl-grid]');
        if (g) window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - headerH() - 16, behavior: 'smooth' });
      });
      acts.appendChild(see);
      txt.appendChild(acts);
      /* Des coups de cœur sans image (anciens enregistrements) : pas de mur vide, le texte seul */
      hero.classList.toggle('bvf-wlh--txt', !wall.children.length);
      if (wall.children.length) hero.appendChild(wall);
      hero.appendChild(txt);
      root.classList.add('bvf-wlh-on');
    }
    render();
    document.addEventListener('bisou:wishlist', function () { setTimeout(render, 60); });
  });

  /* ---------- 10. Visuels à fond opaque : le fond s'efface sur les murs ----------
     15/10 (retour Max : « une bordure blanche autour » sur les derniers tirages ajoutés depuis l'application).
     Mesuré au pixel : ces visuels ont exactement le même cadrage que les autres, mais un fond gris clair opaque
     (#f7f7f7) au lieu d'un fond transparent. Sur les murs (Associez-le, simulateur, wishlist, bande « Composer »,
     ambiances) et dans le panier, il se voyait comme une boîte autour du cadre. On l'efface à l'affichage en partant des bords :
     seuls les pixels de la couleur du fond, reliés au bord de l'image, deviennent transparents ; le cadre,
     le passe-partout et le papier ne sont pas touchés. Un visuel déjà transparent reste tel quel.
     Origine : le studio de l'App peint ce fond à l'export (« fond derrière l'image : #F7F7F7 », règle du 12/08) ;
     les cinq lauréates de la saison 8 sont les premières fiches faites ainsi. Ailleurs (cartes de collection,
     fiche produit), le fond de la page est lui aussi #f7f7f7 : rien à effacer. Le zoom de la fiche (fond blanc)
     et les cartes du Journal (papier #f2f1ee) le montraient. Case dédiée : « Visuels à fond gris ». */
  safe(function () {
    if (!has('bvf-a-fond') || !window.URL || !URL.createObjectURL || !window.MutationObserver) return;
    var SEL = '.bvf-assoc img, #BRPlanner .br-frame img, .bvf-wlh img, .bvf-compose img, .bca img, img.cart-item__image, img.bvf-cduo__img, .product-media-modal img, .bj-pc__im img';
    var done = {}, wait = {};
    function abs(src) { return src.indexOf('//') === 0 ? location.protocol + src : src; }
    function eligible(src) { return /\/files\/[^?#]+\.png(?:[?#]|$)/i.test(src || ''); }
    function swap(img, url) {
      if (!url || img.getAttribute('src') === url) return;
      if (!img.hasAttribute('data-bvf-osrc')) {
        img.setAttribute('data-bvf-osrc', img.getAttribute('src') || '');
        if (img.hasAttribute('srcset')) { img.setAttribute('data-bvf-osrcset', img.getAttribute('srcset')); img.removeAttribute('srcset'); }
      }
      img.src = url;
    }
    function clean(src, cb) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight;
          if (!w || !h || w * h > 4000000) return cb('');
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var x = c.getContext('2d');
          x.drawImage(im, 0, 0);
          /* Les quatre coins d'abord : un fond transparent ou foncé, on s'arrête là */
          var pts = [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]];
          for (var n = 0; n < 4; n++) {
            var cp = x.getImageData(pts[n][0], pts[n][1], 1, 1).data;
            if (cp[3] < 255 || cp[0] < 236 || cp[0] > 252 || Math.abs(cp[0] - cp[1]) > 3 || Math.abs(cp[1] - cp[2]) > 3) return cb('');
          }
          var id = x.getImageData(0, 0, w, h), d = id.data;
          var r0 = d[0], g0 = d[1], b0 = d[2];
          var seen = new Uint8Array(w * h), q = new Int32Array(w * h), qh = 0, qt = 0;
          function push(p) {
            if (seen[p]) return;
            var k = p * 4;
            if (Math.abs(d[k] - r0) > 3 || Math.abs(d[k + 1] - g0) > 3 || Math.abs(d[k + 2] - b0) > 3) return;
            seen[p] = 1; q[qt++] = p;
          }
          for (var i = 0; i < w; i++) { push(i); push((h - 1) * w + i); }
          for (var j = 0; j < h; j++) { push(j * w); push(j * w + w - 1); }
          while (qh < qt) {
            var p = q[qh++], px = p % w;
            if (px > 0) push(p - 1);
            if (px < w - 1) push(p + 1);
            if (p >= w) push(p - w);
            if (p < w * (h - 1)) push(p + w);
          }
          for (var t = 0; t < qt; t++) d[q[t] * 4 + 3] = 0;
          x.putImageData(id, 0, 0);
          c.toBlob(function (b) { cb(b ? URL.createObjectURL(b) : ''); }, 'image/png');
        } catch (e) { cb(''); }
      };
      im.onerror = function () { cb(''); };
      im.src = src;
    }
    function process(img) {
      if (isOff() || img.hasAttribute('data-bvf-osrc')) return;
      var src = img.currentSrc || img.getAttribute('src') || '';
      if (!eligible(src)) return;
      src = abs(src);
      if (done.hasOwnProperty(src)) { if (done[src]) swap(img, done[src]); return; }
      if (wait[src]) { wait[src].push(img); return; }
      wait[src] = [img];
      clean(src, function (url) {
        done[src] = url;
        var list = wait[src] || [];
        delete wait[src];
        if (url) list.forEach(function (im) { if (im.isConnected) swap(im, url); });
      });
    }
    function watch(img) {
      if (img.hasAttribute('data-bvf-osrc')) return;
      var src = abs(img.getAttribute('src') || '');
      /* Déjà traité ailleurs sur la page : on remplace tout de suite, sans montrer la boîte */
      if (done[src]) { swap(img, done[src]); return; }
      if (img.complete && img.naturalWidth) process(img);
      else if (!img.__bvfDm) { img.__bvfDm = 1; img.addEventListener('load', function () { process(img); }); }
    }
    function scan(rootEl) {
      if (isOff()) return;
      var list = rootEl.querySelectorAll ? rootEl.querySelectorAll('img') : [];
      if (rootEl.tagName === 'IMG') list = [rootEl];
      Array.prototype.forEach.call(list, function (img) { if (img.matches(SEL)) watch(img); });
    }
    function revert() {
      document.querySelectorAll('img[data-bvf-osrc]').forEach(function (img) {
        var s = img.getAttribute('data-bvf-osrcset');
        if (s) img.setAttribute('srcset', s);
        img.src = img.getAttribute('data-bvf-osrc');
        img.removeAttribute('data-bvf-osrc');
        img.removeAttribute('data-bvf-osrcset');
      });
    }
    scan(document);
    new MutationObserver(function (muts) {
      if (isOff()) return;
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (nd) { if (nd.nodeType === 1) scan(nd); });
        if (m.type !== 'attributes') return;
        var t = m.target;
        if (t.tagName !== 'IMG' || !t.matches(SEL) || (t.getAttribute('src') || '').indexOf('blob:') === 0) return;
        /* Une image réutilisée (« Essayer un autre ») reçoit une nouvelle adresse : on la reprend */
        t.removeAttribute('data-bvf-osrc');
        t.removeAttribute('data-bvf-osrcset');
        watch(t);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    onMode(function () { if (isOff()) revert(); else scan(document); });
  });

  /* ---------- 11. Wishlist : l'adresse sans « ?view=wishlist » mène à la liste ----------
     /pages/wishlist seule affiche la page vide « Coups de cœur » (seul son titre) : la liste vit sur le gabarit
     ?view=wishlist, celui des liens du site. Un lien ancien ou tapé à la main y est conduit. */
  safe(function () {
    if (!has('bvf-a-planner') || (window.Shopify && window.Shopify.designMode)) return;
    var path = location.pathname.replace(/^\/(en|fr|es|ja)(?=\/)/, '').replace(/\/$/, '');
    if (path !== '/pages/wishlist' || /[?&]view=/.test(location.search) || document.querySelector('.bwl__body')) return;
    var q = location.search ? location.search + '&view=wishlist' : '?view=wishlist';
    location.replace(location.pathname + q + location.hash);
  });

  /* ---------- 21. Collections à thème : /collections/all?sujet=<clé> (17/10) ----------
     Pont tant que les vraies collections Shopify n'existent pas (snippet bvf-collections) : le titre et le nombre
     sont ceux de la collection. 28/10 (Max : « une grande bulle verte […] pour que ça soit mis en avant. Et puis
     après, si on continue de descendre, on a quand même les autres ») : les tirages de la collection montent dans
     une bulle arrondie, à sa couleur, en tête de la grille, dans l'ordre de la grille (« En vedette » : les plus
     vendus et les n° 1 du vote d'abord) ; les autres tirages restent dessous, sous « Tous nos autres tirages ».
     La bulle est un <li> de #product-grid : cadre, couleur du mur et vue de la barre s'y appliquent aussi.
     Tout revient à sa place en « Avant ». Limite : une seule page de grille (41 tirages au 28/10). */
  safe(function () {
    if (!has('bvf-a-coll')) return;
    var cj = document.getElementById('bvf-coll');
    if (!cj) return;
    var data;
    try { data = JSON.parse(cj.textContent); } catch (e) { return; }
    var key = null;
    try { key = new URLSearchParams(location.search).get('sujet'); } catch (e) { key = null; }
    if (!key) return;
    var g = (data.g || []).filter(function (x) { return x.k === key; })[0];
    if (!g) return;
    /* La carte de cette collection ne se repropose pas dans « Autres collections » */
    document.querySelectorAll('.cc__cell[data-bvf-sujet="' + key + '"]').forEach(function (c) { c.setAttribute('data-bvf-cur', ''); });
    if (!data.p) return;
    root.classList.add('bvf-sujet-on');
    var h1 = document.querySelector('.collection-hero__title');
    var tNode = null, tOrig = '';
    if (h1) {
      for (var i = h1.childNodes.length - 1; i >= 0; i--) {
        var nd = h1.childNodes[i];
        if (nd.nodeType === 3 && nd.nodeValue.trim()) { tNode = nd; tOrig = nd.nodeValue; break; }
      }
    }
    var sup = document.querySelector('.collection-hero__count');
    var supOrig = sup ? sup.textContent : '';
    var docOrig = document.title;
    var parked = [], bulle = null, suite = null;
    /* Couleurs : la famille de la puce de chaque collection (bisou-alt-plus.css § 2 ter) ; en sombre (et chocolat),
       un voile de la même teinte sur le brun.
       28/10, 19 h 05 (Max : « ça marche pas du tout le fond en bulle de couleur […] il faut vraiment que ça soit
       comme avec les cartes, comme dans Toutes nos collections […] et qu'il y ait aussi un fond de couleur ») : les
       tirages de la bulle prennent la carte des rangées de l'accueil et de Toutes nos collections (bisou-carte-tirage,
       bisou-collection-ambiance.css « 28/10 ») : passe-partout gris carré arrondi à 10 px, tirage à 3,5 % du bord, titre
       centré dans la serif du Journal, « artiste · dès 35 € ». Ils sont posés sur un grand fond arrondi à la couleur de
       la collection, la même que la rangée de Toutes nos collections (bisou-collection-ambiance.css, --bca-bulle) : les
       deux pages changent ensemble. En sombre, la carte prend le brun des cartes de Toutes nos collections. La zone a
       sa grille (la vue 3, 4 ou 5 de la barre ne la règle pas) ; le cadre choisi change toujours l'image ; la couleur
       du mur, non : la carte reste grise, comme à l'accueil. */
    if (!document.getElementById('bvf-bulle-css')) {
      var css = document.createElement('style');
      css.id = 'bvf-bulle-css';
      css.textContent = [
        '#product-grid>.bvf-bulle{--bvf-bulle:#e6ece0;flex:0 0 100%;width:100%;max-width:100%;list-style:none;box-sizing:border-box;',
        'margin:0;padding:clamp(14px,1.9vw,36px);border-radius:clamp(20px,2.2vw,40px);background:var(--bvf-bulle);animation:bvf-bulle-in .45s ease backwards}',
        '#product-grid>.bvf-bulle[data-sujet="campagne"]{--bvf-bulle:#d9e6cb}',
        '#product-grid>.bvf-bulle[data-sujet="montagne"]{--bvf-bulle:#dbe4ec}',
        '#product-grid>.bvf-bulle[data-sujet="mer"]{--bvf-bulle:#d2e5ee}',
        '#product-grid>.bvf-bulle[data-sujet="ville"]{--bvf-bulle:#ebdfd4}',
        '#product-grid>.bvf-bulle[data-sujet="desert"]{--bvf-bulle:#efe2c4}',
        ':root.br-sombre #product-grid>.bvf-bulle{--bvf-bulle:rgba(214,200,170,.10)}',
        ':root.br-sombre #product-grid>.bvf-bulle[data-sujet="campagne"]{--bvf-bulle:rgba(150,190,110,.20)}',
        ':root.br-sombre #product-grid>.bvf-bulle[data-sujet="montagne"]{--bvf-bulle:rgba(150,180,210,.17)}',
        ':root.br-sombre #product-grid>.bvf-bulle[data-sujet="mer"]{--bvf-bulle:rgba(110,180,205,.18)}',
        ':root.br-sombre #product-grid>.bvf-bulle[data-sujet="ville"]{--bvf-bulle:rgba(215,170,135,.16)}',
        ':root.br-sombre #product-grid>.bvf-bulle[data-sujet="desert"]{--bvf-bulle:rgba(225,190,115,.17)}',
        '#product-grid>.bvf-bulle>.product-grid{margin:0;padding:0}',
        /* La carte de l'accueil, dans la bulle seulement : celles du dessous restent celles de la galerie. */
        /* Une grille à elle, de l'air entre les cartes comme dans les rangées : 2 au téléphone, 3, 4 puis 5 à l'ordinateur
           (la taille des cartes de Toutes nos collections ; GOUT_DE_MAX, « cinq par rangée »). auto-fit : une collection de
           4 tirages (Campagne, Désert) ou une bulle réduite par un filtre se centre au lieu de laisser un trou à droite. */
        '#product-grid>.bvf-bulle>.product-grid.grid{display:grid!important;grid-template-columns:repeat(auto-fit,calc((100% - 10px)/2));justify-content:center;gap:22px 10px!important}',
        '#product-grid>.bvf-bulle>.product-grid>.grid__item{width:auto!important;max-width:none!important;min-width:0;margin:0!important}',
        '@media (min-width:750px){#product-grid>.bvf-bulle>.product-grid.grid{grid-template-columns:repeat(auto-fit,calc((100% - 36px)/3));gap:30px 18px!important}}',
        '@media (min-width:990px){#product-grid>.bvf-bulle>.product-grid.grid{grid-template-columns:repeat(auto-fit,calc((100% - 54px)/4))}}',
        '@media (min-width:1400px){#product-grid>.bvf-bulle>.product-grid.grid{grid-template-columns:repeat(auto-fit,calc((100% - 72px)/5))}}',
        '.bvf-bulle .card-wrapper,.bvf-bulle .card,.bvf-bulle .card__inner{background:none!important;box-shadow:none!important;border:0!important}',
        '.bvf-bulle .card-wrapper{transition:transform .35s cubic-bezier(.2,.7,.2,1)}',
        '@media (hover:hover) and (pointer:fine){.bvf-bulle .grid__item:hover .card-wrapper{transform:translateY(-6px)}}',
        '@media (prefers-reduced-motion:reduce){.bvf-bulle .card-wrapper{transition:none}}',
        /* Deux id : la grille de la page met le carré à angle droit (.card--standard) et le peint par son id, en clair
           comme en sombre (:root.br-sombre:not(#br-0)) ; sans ça, coins carrés sous le passe-partout arrondi. */
        '#ProductGridContainer #product-grid>.bvf-bulle .card__inner{--ratio-percent:100%!important;border-radius:10px!important;overflow:hidden;background:#f7f7f7!important}',
        ':root.br-sombre #ProductGridContainer #product-grid>.bvf-bulle :is(.card__inner,.card__media,.card__media .media){background:rgb(var(--br-surface))!important}',
        '.bvf-bulle .card__inner.ratio:before{padding-bottom:100%!important}',
        '.bvf-bulle .card__inner>.card__content{display:none!important}',
        '.bvf-bulle .card__media,.bvf-bulle .card__media .media{background:#f7f7f7!important;border-radius:10px!important}',
        '.bvf-bulle .card__media .media img{object-fit:contain!important;padding:3.5%!important;box-sizing:border-box;border-radius:0!important;box-shadow:none!important;transform:none!important}',
        '.bvf-bulle .card__media .media img+img{display:none!important}',
        '.bvf-bulle .card>.card__content{padding:12px 2px 0!important;text-align:center}',
        '.bvf-bulle .card>.card__content .card__information{display:flex;flex-flow:row wrap;justify-content:center;align-items:baseline;gap:4px 0;padding:0!important;text-align:center}',
        '.bvf-bulle .card>.card__content .card__heading{flex:0 0 100%;min-width:0;margin:0!important;text-align:center}',
        ".bvf-bulle .card>.card__content .card__heading-text{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;white-space:normal;font-family:'Cormorant Garamond','Cormorant',Garamond,'Times New Roman',serif!important;font-variant-numeric:lining-nums;font-size:clamp(17px,.35vw + 13px,20px)!important;font-weight:500!important;line-height:1.12!important;letter-spacing:0!important;text-transform:none!important;color:rgb(var(--color-foreground))}",
        '.bvf-bulle .card>.card__content .card-information{display:flex;flex-flow:row nowrap;justify-content:center;align-items:baseline;min-width:0;max-width:100%;margin:0;padding:0}',
        '.bvf-bulle .card-information>.caption-with-letter-spacing{min-width:0;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
        '.bvf-bulle .card-information .bisou-card-artist,.bvf-bulle .card-information .bisou-card-artist *,.bvf-bulle .bvf-carte-prix{font-family:var(--font-body-family)!important;font-size:clamp(12px,.15vw + 10px,13.5px)!important;letter-spacing:.01em!important;line-height:1.35!important;text-transform:none!important}',
        '.bvf-bulle .card-information .bisou-card-artist,.bvf-bulle .card-information .bisou-card-artist *{color:rgba(var(--color-foreground),.62)!important}',
        '.bvf-bulle .card-information>.caption-large,.bvf-bulle .card-information>.price{display:none!important}',
        '.bvf-carte-prix{display:none}',
        '.bvf-bulle .bvf-carte-prix{display:inline;flex:0 0 auto;white-space:nowrap;color:rgb(var(--color-foreground))}',
        ".bvf-bulle .bvf-carte-prix:before{content:'·';margin:0 .45em;color:rgba(var(--color-foreground),.4)}",
        '.bvf-bulle .card__badge{display:none!important}',
        '.bvf-bulle__nom{margin:0 0 clamp(10px,1.2vw,20px);text-align:center;font-family:var(--font-heading-family);font-size:13px;letter-spacing:.14em;',
        'text-transform:uppercase;color:rgba(var(--color-foreground),.85)}',
        '#product-grid>.bvf-bulle-suite{flex:0 0 100%;width:100%;max-width:100%;list-style:none;margin:clamp(14px,2vw,36px) 0 0;padding:0}',
        '.bvf-bulle-suite h2{margin:0 0 clamp(10px,1vw,16px);font-family:var(--font-heading-family);font-size:12px;font-weight:400;letter-spacing:.14em;',
        'text-transform:uppercase;color:rgba(var(--color-foreground),.6)}',
        /* Jusqu'à 1 440 px la grille va d'un bord à l'autre (bisou-collection-grid) : la bulle s'en écarte de la marge du
           site, alignée sur le bandeau du dessus, pour garder sa forme ; l'intertitre aussi. Au téléphone, 8 px seulement. */
        '@media (max-width:1440px){#product-grid>.bvf-bulle{--bvf-m:clamp(16px,4vw,60px);flex-basis:calc(100% - 2*var(--bvf-m));width:calc(100% - 2*var(--bvf-m));margin:0 var(--bvf-m)}',
        '#product-grid>.bvf-bulle-suite{padding:0 clamp(16px,4vw,60px)}}',
        '@media (max-width:749px){#product-grid>.bvf-bulle{--bvf-m:8px;padding:12px 10px 10px;border-radius:22px}.bvf-bulle__nom{margin:2px 6px 12px;text-align:left}}',
        '@keyframes bvf-bulle-in{from{opacity:0}}',
        '@media (prefers-reduced-motion:reduce){#product-grid>.bvf-bulle{animation:none}}'
      ].join('');
      document.head.appendChild(css);
    }
    function handleOf(li) {
      var a = li.querySelector('a[href*="/products/"]');
      var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    }
    /* « dès €35 » : le prix du cœur de la carte (data-price, au format de la boutique) sans les zéros, comme
       carte_tirage.des_html à l'accueil ; posé une fois par carte, visible dans la bulle seulement. */
    function habille(li) {
      var info = li.querySelector('.card > .card__content .card-information');
      if (!info || info.querySelector('.bvf-carte-prix')) return;
      var c = li.querySelector('[data-price]');
      var p = c && (c.getAttribute('data-price') || '').trim();
      if (!p) return;
      p = p.replace(/[.,]00(?=\D*$)/, '');
      var sp = document.createElement('span');
      sp.className = 'bvf-carte-prix';
      sp.textContent = selon('dès ' + p, 'from ' + p, 'desde ' + p, p + ' から');
      info.appendChild(sp);
    }
    function member(h) {
      var ks = h && data.p[h];
      return !!ks && (' ' + ks + ' ').indexOf(' ' + key + ' ') > -1;
    }
    function restore() {
      parked.forEach(function (pk) { if (pk.mark.parentNode) pk.mark.parentNode.replaceChild(pk.li, pk.mark); });
      parked = [];
      if (bulle) bulle.remove();
      if (suite) suite.remove();
      bulle = suite = null;
      if (tNode) tNode.nodeValue = tOrig;
      if (sup) sup.textContent = supOrig;
      document.title = docOrig;
      var e = document.querySelector('[data-bvf="sujet-empty"]');
      if (e) e.remove();
    }
    /* Le rangement d'un votant (bisou-collection-grid) peut déplacer des cartes après nous : la bulle reste en tête.
       Le filtre de couleur (bisou-collection-nav, applyColor) range toutes les cartes de la page, celles de la bulle
       comprises, à même #product-grid : celles de la collection reviennent dans la bulle, dans ce nouvel ordre. */
    function enTete(grid) {
      if (!bulle || bulle.parentNode !== grid) return;
      var ul = bulle.lastElementChild;
      Array.prototype.slice.call(grid.children).forEach(function (li) {
        if (li.matches('li.grid__item') && member(handleOf(li))) { habille(li); ul.appendChild(li); }
      });
      if (grid.firstElementChild !== bulle) grid.insertBefore(bulle, grid.firstElementChild);
      if (suite && bulle.nextElementSibling !== suite) grid.insertBefore(suite, bulle.nextElementSibling);
    }
    function apply() {
      if (isOff()) { restore(); return; }
      var grid = document.getElementById('product-grid');
      if (!grid || (bulle && bulle.parentNode === grid)) return;
      bulle = suite = null;
      var cartes = Array.prototype.filter.call(grid.children, function (li) { return li.matches('li.grid__item'); });
      var miens = cartes.filter(function (li) { return member(handleOf(li)); });
      var n = miens.length;
      if (n) {
        bulle = el('li', 'bvf-bulle');
        bulle.setAttribute('data-bvf', 'bulle');
        bulle.setAttribute('data-sujet', key);
        var nom = el('p', 'bvf-bulle__nom');
        nom.textContent = g.n;
        var ul = el('ul', grid.className);
        ul.setAttribute('role', 'list');
        miens.forEach(function (li) {
          var mark = document.createComment('bvf-sujet');
          li.parentNode.replaceChild(mark, li);
          parked.push({ mark: mark, li: li });
          habille(li);
          ul.appendChild(li);
        });
        bulle.appendChild(nom);
        bulle.appendChild(ul);
        grid.insertBefore(bulle, grid.firstChild);
        if (cartes.length > n) {
          suite = el('li', 'bvf-bulle-suite');
          suite.setAttribute('data-bvf', 'bulle-suite');
          suite.appendChild(el('h2', null, 'Tous nos autres tirages'));
          grid.insertBefore(suite, bulle.nextSibling);
        }
      }
      if (tNode) tNode.nodeValue = g.n;
      if (sup) sup.textContent = String(n);
      document.title = g.n + (docOrig.indexOf('–') > -1 ? ' –' + docOrig.split('–').slice(1).join('–') : '');
      var empty = document.querySelector('[data-bvf="sujet-empty"]');
      if (!n && !empty) {
        empty = el('p', 'bvf-sujet-empty', tr('Aucun tirage de cette collection avec ces filtres.'));
        empty.setAttribute('data-bvf', 'sujet-empty');
        grid.parentNode.insertBefore(empty, grid);
      } else if (n && empty) { empty.remove(); }
    }
    /* Le nombre de l'en-tête est recompté par bisou-collection-nav (updateCount) sur toute la grille, autres tirages
       compris : il garde ici ceux de la bulle que les filtres de la page (orientation, édition, couleur) laissent
       voir. Une bulle vidée par un filtre se cache, avec son intertitre, et la phrase « Aucun tirage… » la remplace. */
    var tic = 0;
    function recompte() {
      tic = 0;
      if (isOff()) return;
      if (!bulle || !bulle.isConnected) {
        if (sup && document.querySelector('[data-bvf="sujet-empty"]') && sup.textContent !== '0') sup.textContent = '0';
        return;
      }
      var v = 0;
      bulle.querySelectorAll('li.grid__item').forEach(function (li) { if (getComputedStyle(li).display !== 'none') v++; });
      if (sup && sup.textContent !== String(v)) sup.textContent = String(v);
      if (bulle.hidden !== !v) bulle.hidden = !v;
      if (suite && suite.hidden !== !v) suite.hidden = !v;
      var empty = document.querySelector('[data-bvf="sujet-empty"]');
      var grid = bulle.parentNode;
      if (!v && !empty && grid) {
        empty = el('p', 'bvf-sujet-empty', 'Aucun tirage de cette collection avec ces filtres.');
        empty.setAttribute('data-bvf', 'sujet-empty');
        grid.parentNode.insertBefore(empty, grid);
      } else if (v && empty) { empty.remove(); }
    }
    function plusTard() { if (!tic) tic = (window.requestAnimationFrame || setTimeout)(recompte); }
    if (window.MutationObserver) {
      if (sup) new MutationObserver(plusTard).observe(sup, { childList: true, characterData: true, subtree: true });
      new MutationObserver(plusTard).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    function keepParam() {
      try {
        var u = new URL(location.href);
        if (!u.searchParams.get('sujet')) { u.searchParams.set('sujet', key); history.replaceState(history.state, '', u.toString()); }
      } catch (e) { /* adresse laissée telle quelle */ }
    }
    apply();
    plusTard();
    /* Filtrer re-rend la grille (facets.js) : on refait la bulle sur la grille neuve */
    var host = document.getElementById('ProductGridContainer');
    if (host && window.MutationObserver) {
      new MutationObserver(function () {
        var grid = document.getElementById('product-grid');
        if (grid) enTete(grid);
        if (!grid || grid.getAttribute('data-bvf-sujet') === key || isOff()) return;
        parked = parked.filter(function (pk) { return pk.mark.isConnected; });
        apply();
        plusTard();
        grid.setAttribute('data-bvf-sujet', key);
        keepParam();
      }).observe(host, { childList: true, subtree: true });
      var g0 = document.getElementById('product-grid');
      if (g0) g0.setAttribute('data-bvf-sujet', key);
    }
    onMode(function () { if (isOff()) restore(); else { apply(); plusTard(); } });
  });

  /* ---------- 22. Carte du monde de l'accueil : commandes posées sur la carte (17/10, Max) ----------
     « Le globe et le planisphère sont bien, pas les textes autour, encore moins le + et le − ». Ici : la bascule
     À plat / Globe passe dans le cadre de la carte, en haut à gauche, face au zoom ; le reste se règle en CSS (§ 22).
     En « Avant », la bascule revient à sa place. */
  safe(function () {
    if (!has('bvf-a-atlas2')) return;
    document.querySelectorAll('.bcm--compact').forEach(function (sec) {
      var views = sec.querySelector('[data-bcm-views]');
      var frame = sec.querySelector('[data-bcm-frame]');
      if (!views || !frame) return;
      var mark = document.createComment('bvf-views');
      views.parentNode.insertBefore(mark, views);
      function place() {
        if (isOff()) {
          if (views.parentNode !== mark.parentNode) mark.parentNode.insertBefore(views, mark.nextSibling);
          views.classList.remove('bvf-bcm-views');
        } else {
          if (views.parentNode !== frame) frame.appendChild(views);
          views.classList.add('bvf-bcm-views');
        }
      }
      place();
      onMode(place);
    });
  });

  /* ---------- 23. Collections : les filtres d'édition vides (17/10) — retiré le 21/10 ----------
     Max, 21/10 (v4-5) : « tu peux mettre open édition 0. Comme ça, on pourra anticiper sur l'avenir. »
     « Open edition » reste donc affiché avec son compteur, même à 0 : plus rien ne le cache. */

  /* ---------- 8. Notre histoire : palette neutre (dans le CSS) ----------
     Ici : une intro réduite à un point (champ « vidé » dans l'éditeur) est marquée pour être masquée. */
  safe(function () {
    if (!has('bvf-a-histoire')) return;
    function tidy() {
      document.querySelectorAll('[id^="bnh-"] .bnh__intro').forEach(function (p) {
        if (/^[\s.·•-]*$/.test(p.textContent)) p.setAttribute('data-bvf-empty', '');
      });
    }
    tidy();
    document.addEventListener('shopify:section:load', tidy);
  });

  /* ---------- 24. L'orientation suit le client d'une collection à l'autre (25/10, règle R18b) ----------
     Relevé « algorithme » (lot 1) : ?orient= se perdait en passant d'une collection à une autre. Le choix fait
     dans la bascule (Horizontales, Verticales, Tous) est gardé pour la visite (sessionStorage br_orient) ; au clic
     sur un lien vers une collection, il passe par le relais que la barre des collections lit déjà
     (br_colnav_intent, lu une fois), qui le réécrit dans l'adresse : toujours visible dans la bascule, « Tous »
     l'enlève. Seulement les liens vers une collection : ni l'accueil, ni la recherche, ni les fiches ; ni
     Horizontal ni Vertical, ni un lien qui porte déjà son filtre. En « Avant », rien. */
  safe(function () {
    if (!has('bvf-a-coll')) return;
    var KEY = 'br_orient';
    var COLL = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([^\/?#]+)\/?$/i;
    function get() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
    function set(v) {
      try { if (v === 'h' || v === 'v') sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {}
    }
    /* Un lien partagé (?orient=h|v) vaut un choix */
    if (COLL.test(location.pathname)) {
      var o = new URLSearchParams(location.search).get('orient');
      if (o === 'h' || o === 'v') set(o);
    }
    document.addEventListener('click', function (e) {
      if (isOff() || !e.target.closest) return;
      /* « Réinitialiser » de la grille vide remet aussi « Tous » : le choix de la visite s'efface avec. */
      var tab = e.target.closest('.bisou-colnav__tab[data-orient], .bisou-colnav__empty-reset');
      if (tab) { set(tab.getAttribute('data-orient')); return; }
      var a = e.target.closest('a[href]'), m = get();
      if (!a || !m) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      var c = u.origin === location.origin && u.pathname.match(COLL);
      if (!c || /^(horizontal|vertical)$/i.test(c[1])) return;
      if (['view', 'orient', 'edition', 'color'].some(function (k) { return u.searchParams.has(k); })) return;
      try { localStorage.setItem('br_colnav_intent', JSON.stringify({ orient: m })); } catch (err) {}
    }, true);
  });

  /* ---------- 25. La langue : une proposition discrète, une fois (25/10, règle R18c) ----------
     Relevé « algorithme » (lot 1) : la langue, c'est l'adresse (/en/…) ; le thème ne redirige jamais, et ne le fera
     pas. Un visiteur dont le navigateur ne parle pas français voit, sur une page en français, une petite pastille
     « View in English? » qui mène à la même page en anglais (le lien hreflang que Shopify écrit dans la page).
     Une seule fois (localStorage br_lang_offer : vu, en ou fr) : suivie, fermée ou ignorée, elle ne revient plus.
     Ni sur une fiche, ni au panier, ni au compte (la barre d'achat du bas reste libre) : elle attend une autre page,
     et attend que le bandeau des cookies soit fermé, pour ne jamais s'y superposer. En anglais, puisqu'elle s'adresse
     à qui ne lit pas le français. Rangée avec le menu (sa case) : c'est lui qui porte déjà la langue. En « Avant », rien. */
  safe(function () {
    if (!has('bvf-a-volet') || isOff()) return;
    var KEY = 'br_lang_offer';
    if ((root.getAttribute('lang') || '').toLowerCase().indexOf('fr') !== 0) return;
    var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    if ([].some.call(langs, function (l) { return /^fr\b/i.test(l || ''); })) return;
    try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }
    if (/\/(products|cart|checkouts?|account)(\/|$)/.test(location.pathname)) return;
    var alt = document.querySelector('link[rel="alternate"][hreflang="en"]');
    var u;
    try { u = new URL(alt.getAttribute('href'), location.href); u.search = location.search; u.hash = location.hash; } catch (e) { return; }
    function keep(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function cookieOpen() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var s = getComputedStyle(b);
      return s.display !== 'none' && s.visibility !== 'hidden' && b.getClientRects().length > 0;
    }
    function show() {
      if (isOff() || document.querySelector('.bvf-lang')) return;
      /* R18e (lot 2c) : au plus une fenêtre par visite (mémoire commune de bisou-popups.js). Une autre s'est déjà
         montrée : la pastille attend la visite suivante, sans être notée « vu ». */
      try {
        if (sessionStorage.getItem('br_fenetre_visite')) return;
        sessionStorage.setItem('br_fenetre_visite', 'langue');
      } catch (e) {}
      keep('vu');
      var box = el('div', 'bvf-lang');
      box.setAttribute('lang', 'en');
      var go = el('a', 'bvf-lang__go', 'View in English?');
      go.href = u.href;
      go.setAttribute('hreflang', 'en');
      go.addEventListener('click', function () { keep('en'); });
      var x = el('button', 'bvf-lang__x', '×');
      x.type = 'button';
      x.setAttribute('aria-label', 'No thanks');
      x.addEventListener('click', function () { keep('fr'); box.parentNode && box.parentNode.removeChild(box); });
      box.appendChild(go);
      box.appendChild(x);
      document.body.appendChild(box);
    }
    var tries = 0;
    function wait() {
      if (!cookieOpen()) return show();
      if (++tries < 90) setTimeout(wait, 1000);
    }
    /* Le bandeau des cookies n'est inséré qu'après DOMContentLoaded : on ne le cherche qu'après load. */
    if (document.readyState === 'complete') setTimeout(wait, 1500);
    else window.addEventListener('load', function () { setTimeout(wait, 1500); });
  });
})();
